<template>
  <div>
    <page-head :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="所属区域">
                <Cascader
                  v-model="comList"
                  :data="communityList"
                  placeholder="请选择"
                  clearable
                  @on-change="communityChange"
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="姓名" prop="userName">
                <Input v-model="query.userName" clearable placeholder="请输入姓名" />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="身份证号" prop="idCardNO">
                <Input v-model="query.idCardNO" clearable placeholder="请输入身份证号" />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="手机号码" prop="phoneNO">
                <Input v-model="query.phoneNO" clearable placeholder="请输入手机号码" />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="状态" prop="status">
                <Select v-model="query.statusIndex" clearable>
                  <Option
                    v-for="item in statusList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.status"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="类别" prop="type">
                <Select v-model="query.typeIndex" clearable>
                  <Option
                    v-for="item in typeList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="年龄" prop="ageRange">
                <Select v-model="query.ageRange" clearable>
                  <Option
                    v-for="item in ageList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.age"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="认证时间" prop="eventtime">
                <DatePicker v-model="time" class="time" type="daterange" placeholder="请选择时间"></DatePicker>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="认证状态" prop="status">
                <Select v-model="query.lastFaceVerify" clearable>
                  <Option
                    v-for="item in verifyList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.vType"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isTableLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-row-dblclick="handleClickDetail"
        >
          <template slot-scope="{ row, index }" slot="lastFaceVerify">
            <span
              :class="[row.lastFaceVerify==1 || row.lastFaceVerify==11?'success':'']"
            >{{row.lastFaceVerify == 11?'人工认证成功':row.lastFaceVerify == null || row.lastFaceVerify ==2? '待认证': row.lastFaceVerify ==1?'认证成功':'认证失败'}}</span>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <span @click="handleClickDetail(row)" class="action">[详情]</span>
            <Poptip confirm title="确认删除?" placement="left" @on-ok="handleClickDelete(row)" v-if="showDelete">
              <span style="margin-left:10px;color:#ff7b44">删除</span>
            </Poptip>
          </template>
        </i-table>
        <div class="page">
          <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { ssList, ssDelete, ssExport } = api;
const STATUSMAP = {
  0: {
    status: "正常"
  },
  1: {
    status: "暂停"
  },
  2: {
    status: "新增"
  },
  4: {
    status: "死亡"
  },
  100: {
    status: ""
  }
};
const TYPEMAP = {
  0: {
    type: "居民"
  },
  1: {
    type: "民办教师"
  },
  100: {
    type: ""
  }
};
export default {
  name: "allowance",
  components: {
    pageHead
  },

  data() {
    return {
      showDelete:true,
      statusList: [
        {
          index: 0,
          status: "正常"
        },
        {
          index: 1,
          status: "暂停"
        },
        {
          index: 2,
          status: "新增"
        },
        {
          index: 4,
          status: "死亡",
        },
      ],
      typeList: [
        {
          index: 0,
          type: "居民"
        },
        {
          index: 1,
          type: "民办教师"
        }
      ],
      ageList: [
        // {
        //   index: 0,
        //   age: "全部"
        // },
        {
          index: 1,
          age: "80-90"
        },
          {
          index: 2,
          age: "90-100"
        },
          {
          index: 3,
          age: "100以上"
        }
      ],
      verifyList: [
        {
          index: 0,
          vType: "认证失败"
        },
        {
          index: 11,
          vType: "人工认证成功"
        },
        {
          index: 1,
          vType: "认证成功"
        },
        {
          index: 2,
          vType: "待认证"
        }
      ],
      query: {
        communityId: "",
        userName: "",
        idCardNO: "",
        phoneNO: "",
        beginFaceVerifyTime: "",
        endFaceVerifyTime: "",
        statusIndex: "",
        typeIndex: "",
        lastFaceVerify: "",
        ageRange:""
      },
      time: "",
      communityList: [],
      comList: [],
      isTableLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: "高龄津贴",
      btnList: [
        {
          name: "重置",
          type: "reset"
        },
        {
          name: "搜索",
          type: "search"
        },
        {
          name: "导出",
          type: "export"
        }
      ],
      tableHeader: [
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "所属区域",
          key: "communityName"
        },
        {
          title: "姓名",
          key: "userName"
        },
        {
          title: "年龄",
          key: "age"
        },
        {
          title: "身份证号码",
          key: "idCardNO"
        },
        {
          title: "手机号码",
          key: "phoneNO"
        },
        {
          title: "居住地址",
          key: "address"
        },
        {
          title: "状态",
          key: "status"
        },
        {
          title: "类别",
          key: "type"
        },
        {
          title: "最后一次认证时间",
          key: "lastFaceVerifyTime"
        },
        {
          title: "最近一次认证结果",
          slot: "lastFaceVerify"
        },
        {
          title: "操作",
           width: 160,
          slot: "action"
        }
      ],
      tableData: [],
      header: {
        token: window.sessionStorage.getItem("token")
      }
    };
  },
  methods: {
    async handleClickDelete(row){
      let res = await this.$delete(ssDelete(row.id))
      if(res.isSucceed){
        this.$Message.success("删除成功")
        this.pageChange(this.pageNum)
      }
    },
    handleBtn(type) {
      if (type == "reset") {
        this.time = "";
        this.pageNum = 1;
        this.query.beginFaceVerifyTime = "";
        this.query.endFaceVerifyTime = "";
        this.comList = [];
        this.query.statusIndex = "";
        this.query.typeIndex = "";
        this.query.ageRange = "";
        this.query.lastFaceVerify = "";
        this.query.communityId = this.$store.state.streetorcommunityid;
        this.$refs.search.resetFields();
        this.getSSList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getSSList();
      } else {
        let {
          communityId,
          userName,
          idCardNO,
          phoneNO,
          beginFaceVerifyTime,
          endFaceVerifyTime,
          lastFaceVerify,
          statusIndex,
          typeIndex,
          ageRange
        } = this.query;
        lastFaceVerify = lastFaceVerify?lastFaceVerify:''
        typeIndex = typeIndex?typeIndex:''
        ageRange = ageRange?ageRange:''
        statusIndex = statusIndex?statusIndex:''
        let url =
          ssExport +
          "?communityId=" +
          communityId +
          "&userName=" +
          userName +
          "&idCardNO=" +
          idCardNO +
          "&phoneNO=" +
          phoneNO +
          "&lastFaceVerify=" +
          lastFaceVerify +
          "&statusIndex=" +
          statusIndex +
          "&typeIndex=" +
          typeIndex +
          "&ageRange=" +
          ageRange +
          "&beginFaceVerifyTime=" +
          beginFaceVerifyTime +
          "&endFaceVerifyTime=" +
          endFaceVerifyTime +
          "&comeType=37" +
          "&token=" +
          this.header.token;

        console.log(url);
        window.open(url);
      }
    },
    handleClickDetail(item) {
      console.log(item);
      this.$router.push({
        name: "ssvDetail",
        query: { id: item.id, allowance: 1 }
      });
    },
    pageChange(val) {
      this.pageNum = val;
      this.getSSList();
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770009
      })
        .then(res => {
          this.communityList = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList);
        })
        .catch(e => {
          this.$Message.error("获取行政区域失败");
        });
    },
    formateData(data) {
      let returnData = data.map(item => {
        return {
          value: {
            communityId: item.communityId,
            childrenIdList: item.childrenIdList
          },
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : []
        };
      });
      return returnData;
    },
    communityChange(value) {
      // console.log(value)
      let returndata = value[value.length - 1];
      this.query.communityId = returndata.communityId;
      console.log(this.query.communityId);
    },
    async getSSList() {
      this.isLoading = true;
      try {
        if (this.time[0]) {
          this.query.beginFaceVerifyTime = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          this.query.endFaceVerifyTime = this.$util.FormatDate(
            new Date(this.time[1]),
            "yyyy-MM-dd"
          );
        }
        let res = await this.$post(ssList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          comeType: 37,
          ...this.query
        });
        console.log(this.query);

        let list = res.rows.map(item => ({
          ...item,
          ...STATUSMAP[item.statusIndex != null ? +item.statusIndex : 100],
          ...TYPEMAP[item.typeIndex != null ? +item.typeIndex : 100],
        }));
        // console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    }
  },

  created() {
    //如果是南乐县下的乡，关闭删除按钮
    let path = this.$store.state.path + ''
    let patharr = path.split(',')
    if(patharr.length >4 && path.indexOf('410923000000')>-1){
      this.showDelete = false
    }
    // /
    this.getCommunity();
    this.query.communityId = this.$store.state.streetorcommunityid;
    
    this.getSSList();

    
  },
  mounted() {}
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.time {
  width: 100%;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .success {
    color: #ff7b44;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}
</style>